import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import {
    Row,
    Col,
    Input,
    Card,
    CardImg,
    CardBody,
    Collapse,
    ListGroup,
    ListGroupItem,
    CardHeader,
    Button,
    Container,
    Form,
    FormGroup,
    Label,
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap';
import classnames from 'classnames';
import { useForm } from 'react-hook-form';
import Select from 'react-select';
import ReactPlayer from 'react-player/lazy'

import { faCaretDown, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactStars from "react-rating-stars-component";

import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';

import ResourceDifficulties from '../../enums/ResourceDifficulties';
import ResourceLanguages from '../../enums/ResourceLanguages';
import ResourceTypes from '../../enums/ResourceTypes';
import UsaStates from '../../enums/UsaStates';

import Tabs, {TabPane} from 'rc-tabs';
import TabContent from 'rc-tabs/lib/SwipeableTabContent';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';

import { getDisplayItemList } from '../../helpers/GetDisplayItemList';
import { sortItensByInterest } from '../../helpers/SorItensByInterest';
import { prettyUrl } from '../../helpers/PrettyUrl';
// import { getKeyByValue } from '../../helpers/GetKeyByValue';
import { orderObjectByKeys } from '../../helpers/OrderObjectByKeys';
import { getLanguagesFromValues } from '../../helpers/GetLanguagesFromValues';
import { getStatesFromValues } from '../../helpers/GetStatesFromValues';
import { detectYouTubeUrl } from '../../helpers/DetectYouTubeUrl';
import UsaStatesJson from '../../enums/UsaStatesJson';
import predefinedInterests from '../../enums/PredefinedInterests';
import ReportIssues from '../../enums/ReportIssues';

export default function Resources() {
    const { toggleLoading } = useAuth();
    const { register, handleSubmit, reset } = useForm();

    const [errors, setErrors] = useState({});
    const [items, setItems] = useState();
    const [lastId, setLastId] = useState({});

    // const languageOptions = [
    //     { value: '', label: 'ALL' },
    //     { value: ResourceLanguages.ENGLISH, label: 'ENGLISH' },
    //     { value: ResourceLanguages.SPANISH, label: 'SPANISH' },
    //     { value: ResourceLanguages.OTHER, label: 'OTHER' }
    // ];

    const difficultyOptions = [
        { value: '', label: 'ALL' },
        { value: ResourceDifficulties.EASY, label: 'EASY' },
        { value: ResourceDifficulties.INTERMEDIATE, label: 'INTERMEDIATE' },
        { value: ResourceDifficulties.ADVANCED, label: 'ADVANCED' }
    ];

    const defaultSuggestedOption = {
        value: 'suggested',
        label: 'SUGGESTED'
    };
    const defaultAllOption = {
        value: '',
        label: 'ALL'
    };
    const suggestedBadge = 'Suggested';

    const [servicesFilter, setServicesFilter] = useState({});
    const [activitiesFilter, setActivitiesFilter] = useState({});
    const [productsFilter, setProductsFilter] = useState({});
    const [trainingFilter, setTrainingFilter] = useState({});
    const [vaFilter, setVaFilter] = useState({});

    // const [interestSort, setInterestSort] = useState({});
    const [filteredLanguages, setFilteredLanguages] = useState([]);
    const [filteredStates, setFilteredStates] = useState([]);
    const [defaultStateVa, setDefaultStateVa] = useState({value:'', label: 'All States'});

    const [returnedInterestsActivities, setReturnedInterestsActivities] = useState([]);
    const [returnedInterestsProducts, setReturnedInterestsProducts] = useState([]);
    const [returnedInterestsTraining, setReturnedInterestsTraining] = useState([]);

    const [activeAddScreen, setActiveAddScreen] = useState(false);
    const toggleActiveAddScreen = useCallback(() => {
        setActiveAddScreen(!activeAddScreen);
    }, [setActiveAddScreen, activeAddScreen]);
    const [activeSearchScreen, setActiveSearchScreen] = useState(true);
    const toggleActiveSearchScreen = useCallback(() => {
        setActiveSearchScreen(!activeSearchScreen);
    }, [setActiveSearchScreen, activeSearchScreen]);

    const [accordionServices, setAccordionServices] = useState([]);
    const [accordionActivities, setAccordionActivities] = useState([]);
    const [accordionProducts, setAccordionProducts] = useState([]);
    const [accordionTraining, setAccordionTraining] = useState([]);
    const [accordionVa, setAccordionVa] = useState([]);

    const servicesLanguageFilter = useRef();
    const vaStateFilter = useRef();
    
    const activitiesDifficultyFilter = useRef();
    const productsDifficultyFilter = useRef();
    const trainingDifficultyFilter = useRef();

    const activitiesInterestFilter = useRef();
    const productsInterestFilter = useRef();
    const trainingInterestFilter = useRef();

    const toggleAccordion = useCallback((tab, type) => {
        let prevState;
        if (type === 'services') {
            prevState = accordionServices;
        } else if (type === 'activities') {
            prevState = accordionActivities;
        } else if (type === 'products') {
            prevState = accordionProducts;
        } else if (type === 'training') {
            prevState = accordionTraining;
        } else if (type === 'va') {
            prevState = accordionVa;
        }
        
        const newState = prevState.map((x, index) =>
            tab === index ? !x : x
        );

        if (type === 'services') {
            setAccordionServices(newState);
        } else if (type === 'activities') {
            setAccordionActivities(newState);
        } else if (type === 'products') {
            setAccordionProducts(newState);
        } else if (type === 'training') {
            setAccordionTraining(newState);
        } else if (type === 'va') {
            setAccordionVa(newState);
        }
        
    }, [accordionServices, accordionActivities, accordionProducts, accordionTraining, accordionVa, setAccordionServices, setAccordionActivities,  setAccordionTraining, setAccordionVa]);

    const [modalSubmitMessage, setModalSubmitMessage] = useState(false);
    const toggleModalSubmitMessage = useCallback(() => {
        setModalSubmitMessage(!modalSubmitMessage);
    }, [setModalSubmitMessage, modalSubmitMessage]);

    // START: Rate and Report Modals data
    const [currentResourceModal, setCurrentResourceModal] = useState();

    const [rateContent, setRateContent] = useState('');
    const [rateStars, setRateStars] = useState(0);
    const ratingChanged = useCallback((e) => {
        setRateStars(parseInt(e));
    }, [setRateStars]);
    const contentChanged = useCallback((e) => {
        setRateContent(e.target.value);
    }, [setRateContent]);

    const [reportContent, setReportContent] = useState('');
    const [reportMotivation, setReportMotivation] = useState(0);
    const motivationChanged = useCallback((e) => {
        setReportMotivation(e.value);
    }, [setReportMotivation]);
    const descriptionChanged = useCallback((e) => {
        setReportContent(e.target.value);
    }, [setReportContent]);

    // END: Rate and Report Modals data

    // START: Rate and report modals
    const [modalRate, setModalRate] = useState(false);
    const toggleModalRate = useCallback(() => {
        if (!modalRate) {
            setRateContent('');
            setRateStars(0);
        }
        setModalRate(!modalRate);
    }, [setModalRate, modalRate, setRateContent, setRateStars]);

    const [modalRateMessage, setModalRateMessage] = useState(false);
    const toggleModalRateMessage = useCallback(() => {
        setModalRateMessage(!modalRateMessage);
    }, [setModalRateMessage, modalRateMessage]);

    const [modalReport, setModalReport] = useState(false);
    const toggleModalReport = useCallback(() => {
        if (!modalReport) {
            setReportContent('');
            setReportMotivation(0);
        }
        setModalReport(!modalReport);
    }, [setModalReport, modalReport, setReportContent, setReportMotivation]);

    const [modalReportMessage, setModalReportMessage] = useState(false);
    const toggleModalReportMessage = useCallback(() => {
        setModalReportMessage(!modalReportMessage);
    }, [setModalReportMessage, modalReportMessage]);
    // END: Rate and report modals

    // START: Rate and report submits
    const submitRate = useCallback(() => {
        if (currentResourceModal === undefined) {
            return;
        }
        if (currentResourceModal.id === undefined || currentResourceModal.type === undefined){
            return;
        }

        const data = {};
        data.stars = parseInt(rateStars);
        data.content = rateContent;
        data.rId = currentResourceModal.id;
        data.rType = currentResourceModal.type;

        toggleLoading(true);
        api.post('ro.team.insertReview', data)
            .then(() => {
                toggleModalRate();
                toggleModalRateMessage();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [rateStars, rateContent, currentResourceModal, toggleModalRateMessage, toggleModalRate, toggleLoading]);

    const submitReport = useCallback(() => {
        if (currentResourceModal === undefined) {
            return;
        }
        if (currentResourceModal.id === undefined || currentResourceModal.type === undefined){
            return;
        }

        const data = {};
        data.motivation = parseInt(reportMotivation);
        data.content = reportContent;
        data.rId = currentResourceModal.id;
        data.rType = currentResourceModal.type;

        toggleLoading(true);
        api.post('ro.team.insertReport', data)
            .then(() => {
                toggleModalReport();
                toggleModalReportMessage();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [reportMotivation, reportContent, currentResourceModal, toggleModalReport, toggleModalReportMessage, toggleLoading]);
    // END: Rate and report submits

    const [searchParams, setSearchParams] = useState({});
    const toggleSearchParams = useCallback((e) => {
        const localSearch = searchParams;
        localSearch[e.target.name] = e.target.value;
        setSearchParams(localSearch);
        localStorage.setItem('@ReachoutSearch', JSON.stringify(localSearch));
    }, [searchParams, setSearchParams]);
    const [activeSearch, setActiveSearch] = useState(false);

    const toggleInterests = useCallback((e) => {
        var localSearch = searchParams.interests;

        if (localSearch === undefined) {
            localSearch = [];
        }

        if (e.target.checked === true) {
            localSearch.push(e.target.value);
        } else {
            let newInterests = [];
            localSearch.map((item) => {
                if (item !== e.target.value) {
                    newInterests.push(item);
                }
                return true;
            });
            localSearch = newInterests;
        }

        setSearchParams({...searchParams, interests:localSearch});
        localStorage.setItem('@ReachoutSearch', JSON.stringify({...searchParams, interests:localSearch}));
    }, [searchParams, setSearchParams]);

    const [searchTypeZip, setSearchTypeZip] = useState(false);
    const toggleSearchTypeZip = useCallback(() => {
        setSearchTypeZip(!searchTypeZip);
    }, [setSearchTypeZip, searchTypeZip]);

    const mountRemoteInterests = useCallback((type, data) => {
        if (!type || !data) {
            return;
        }
        let currentInterests = [];

        data.map((item) => {
            if (item.interests) {
                const localInterests = item.interests.split('|');
                localInterests.map((i) => {
                    if (currentInterests[i] === undefined) {
                        currentInterests[i] = [];
                    }
                    currentInterests[i].push(item.id);
                    return true;
                });
            }

            return true;
        });

        let interestOptions = [];
        interestOptions.push(defaultAllOption);
        interestOptions.push(defaultSuggestedOption);

        currentInterests = orderObjectByKeys(currentInterests);

        Object.keys(currentInterests).forEach((item) => {
            if (item) {
                interestOptions.push({
                    value: item,
                    label: item.toUpperCase()
                })
            }
        });        
        
        if (type === 'activities') {
            setReturnedInterestsActivities(interestOptions);
        } else if (type === 'products') {
            setReturnedInterestsProducts(interestOptions);
        } else if (type === 'training') {
            setReturnedInterestsTraining(interestOptions);
        }

        return getDisplayItemList({interests:searchParams.interests, topicItemsList:currentInterests});
    }, [searchParams.interests, defaultSuggestedOption, defaultAllOption, setReturnedInterestsActivities, setReturnedInterestsProducts, setReturnedInterestsTraining]);

    const add = useCallback((data) => {
        // Validating the DATA
        const newErrors = {};
        let validation = true;
        if (data.title === null || data.title === '' || data.title === undefined) {
            newErrors.title = ('Title is required');
            validation = false;
        }
        if (data.description === null || data.description === '' || data.description === undefined) {
            newErrors.description = ('Description is required');
            validation = false;
        }
        if (data.url === null || data.url === '' || data.url === undefined) {
            newErrors.url = ('URL is required');
            validation = false;
        }
        if (data.language === null || data.language === '' || data.language === undefined) {
            newErrors.language = ('Language is required');
            validation = false;
        }
        if (data.difficulty === null || data.difficulty === '' || data.difficulty === undefined) {
            newErrors.difficulty = ('Difficulty is required');
            validation = false;
        }
        if (data.type === null || data.type === '' || data.type === undefined) {
            newErrors.type = ('Type is required');
            validation = false;
        }

        if (parseInt(data.type) === ResourceTypes.SERVICES) {
            if (data.state === null || data.state === '' || data.state === undefined) {
                newErrors.state = ('State is required for SERVICES');
                validation = false;
            }
            if (data.zipcode === null || data.zipcode === '' || data.zipcode === undefined) {
                newErrors.zipcode = ('ZIP Code is required for SERVICES');
                validation = false;
            }
        }

        setErrors(newErrors);
        if (!validation) {
            return false;
        }

        let endpoint = '';
        if (parseInt(data.type) === ResourceTypes.SERVICES) {
            endpoint = 'ro.team.insertResource';
        } else {
            endpoint = 'ro.team.insertMultiResource';
        }

        const desiredObject = ResourceLanguages;
        const desiredValue = parseInt(data.language, 10);
        let keyStatus = null;
        for (const [key, value] of Object.entries(desiredObject)) {
            if (value === desiredValue) {
            keyStatus = key;
            }
        }
        const languages = keyStatus.toLowerCase();

        const form_data = {
            zipcode: data.zipcode,
            state: data.state,
            type: parseInt(data.type),
            languageId: parseInt(data.language),
            difficultyId: parseInt(data.difficulty),
            interestsIds: data.tags.replace(',','|'),
            props: JSON.stringify({
                title: data.title,
                desc: data.description,
                url: data.url,
                street: data.street,
                city: data.city,
                state: data.state,
                phone: data.phone,
                email: data.email,
                languages: languages,
            })
        }; 

        toggleLoading(true);
        api.post(endpoint, form_data)
            .then(() => {
                toggleModalSubmitMessage();
                reset();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
        
    }, [reset, toggleLoading, toggleModalSubmitMessage, setErrors]);

    const getZipCodeAPI = useCallback(async () => {
        const result = await api.get('ro.team.getZipCode');
        return result.data;
    }, []);

    useEffect(() => {
        async function getCurrentZip () {
            let current_zip = null;
            if (localStorage.getItem('@ReachoutSearch')) {
                setSearchParams(JSON.parse(localStorage.getItem('@ReachoutSearch')));
                const local = JSON.parse(localStorage.getItem('@ReachoutSearch'));
                if (local.zipcode_search !== undefined && local.zipcode_search !== null && local.zipcode_search !== '') {
                    current_zip = local.zipcode_search;
                }
            }

            if (current_zip === null) {
                const zipcode = await getZipCodeAPI();
                if (zipcode.status) {
                    const newSearchParams = {
                        zipcode_search: zipcode.zipcode
                    }
                    setSearchParams(newSearchParams);
                    localStorage.setItem('@ReachoutSearch', JSON.stringify(newSearchParams));
                }
                // if (navigator.geolocation) {
                //     navigator.geolocation.getCurrentPosition((position) => {
                //     });
                // }
            }
        }
        getCurrentZip();
    }, [setSearchParams, getZipCodeAPI]);

    const preFilterServices = useCallback((items) => {
        const newItems = [];
        items.map((item) => {
            let validation = true;

            // Language filter
            if (searchParams.language_search !== undefined && searchParams.language_search !== null && searchParams.language_search !== '') {
                if (parseInt(item.language) !== parseInt(searchParams.language_search)) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newItems.push(item);

            return true;
        });

        if (servicesLanguageFilter && servicesLanguageFilter.current !== undefined && servicesLanguageFilter.current.state) {
            delete(servicesLanguageFilter.current.state.value)
        }

        return newItems;
    }, [searchParams]);

    const preFilterActivities = useCallback((items) => {
        const newItems = [];
        items.map((item) => {
            let validation = true;

            // Difficulty filter
            if (searchParams.difficulty_search !== undefined && searchParams.difficulty_search !== null && searchParams.difficulty_search !== '') {
                if (parseInt(item.difficulty) !== parseInt(searchParams.difficulty_search)) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newItems.push(item);

            return true;
        });
        
        if (activitiesDifficultyFilter && activitiesDifficultyFilter.current !== undefined && activitiesDifficultyFilter.current.state) {
            delete(activitiesDifficultyFilter.current.state.value)
        }
        if (activitiesInterestFilter && activitiesInterestFilter.current !== undefined && activitiesInterestFilter.current.state) {
            delete(activitiesInterestFilter.current.state.value)
        }

        return newItems;
    }, [searchParams]);

    const preFilterProducts = useCallback((items) => {
        const newItems = [];
        items.map((item) => {
            let validation = true;

            // Difficulty filter
            if (searchParams.difficulty_search !== undefined && searchParams.difficulty_search !== null && searchParams.difficulty_search !== '') {
                if (parseInt(item.difficulty) !== parseInt(searchParams.difficulty_search)) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newItems.push(item);

            return true;
        });

        if (productsDifficultyFilter && productsDifficultyFilter.current !== undefined && productsDifficultyFilter.current.state) {
            delete(productsDifficultyFilter.current.state.value)
        }
        if (productsInterestFilter && productsInterestFilter.current !== undefined && productsInterestFilter.current.state) {
            delete(productsInterestFilter.current.state.value)
        }

        return newItems;
    }, [searchParams]);

    const preFilterTraining = useCallback((items) => {
        const newItems = [];
        items.map((item) => {
            let validation = true;

            if (searchParams.difficulty_search !== undefined && searchParams.difficulty_search !== null && searchParams.difficulty_search !== '') {
                if (parseInt(item.difficulty) !== parseInt(searchParams.difficulty_search)) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newItems.push(item);

            return true;
        });

        if (trainingDifficultyFilter && trainingDifficultyFilter.current !== undefined && trainingDifficultyFilter.current.state) {
            delete(trainingDifficultyFilter.current.state.value)
        }
        if (trainingInterestFilter && trainingInterestFilter.current !== undefined && trainingInterestFilter.current.state) {
            delete(trainingInterestFilter.current.state.value)
        }

        return newItems;
    }, [searchParams]);

    const preFilterVa = useCallback((items, state = null) => {
        let localSearchParams = searchParams;
        if (state) {
            localSearchParams.state_search = state;
        }

        const newItems = [];
        let count = 0;
        items.map((item) => {
            let validation = true;

            if ((localSearchParams.state_search !== undefined && localSearchParams.state_search !== null && localSearchParams.state_search !== '' && !searchTypeZip) || state !== null) {
                if (item.state !== undefined && item.state !== localSearchParams.state_search) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
                count++;
            }
            newItems.push(item);

            return true;
        });


        if (localSearchParams.state_search !== undefined && localSearchParams.state_search !== null && localSearchParams.state_search !== '') {
            if (count === 0) {
                if (vaStateFilter && vaStateFilter.current !== undefined && vaStateFilter.current.state) {
                    vaStateFilter.current.state.value = {value:'', label: 'All States'};
                }
                setDefaultStateVa({value:'', label: 'All States'});
                items.map((item) => {
                    item.hide = false;
                    return item;
                });
            } else {
                setDefaultStateVa({value:localSearchParams.state_search, label: UsaStatesJson[localSearchParams.state_search]});
                if (vaStateFilter && vaStateFilter.current !== undefined && vaStateFilter.current.state) {
                    vaStateFilter.current.state.value = {value:localSearchParams.state_search, label: UsaStatesJson[localSearchParams.state_search]};
                }
            }
            
        } else {
            if (vaStateFilter && vaStateFilter.current !== undefined && vaStateFilter.current.state) {
                vaStateFilter.current.state.value = {value:'', label: 'All States'};
            }
            setDefaultStateVa({value:'', label: 'All States'});
        }        

        return newItems;
    }, [searchParams, searchTypeZip]);

    const toggleFilterServices = useCallback((target = null, value = null) => {
        const currentServicesFilter = servicesFilter;
        currentServicesFilter[target] = value;
        // if (target && value) {
        //     
        // }
        setServicesFilter(currentServicesFilter);

        const currentServices = items.services.items;
        let newServices = [];

        currentServices.map((item) => {
            let validation = true;

            // Language filter
            if (currentServicesFilter.language !== undefined && currentServicesFilter.language !== null && currentServicesFilter.language !== '') {
                if (item.languages !== undefined) {
                    const loc_langs = item.languages.toLowerCase();
                    if (loc_langs && !loc_langs.includes(currentServicesFilter.language)) {
                        validation = false;
                    }
                    if ((item.languages === '' || item.languages === ' ' ) && currentServicesFilter.language === 'english') {
                        validation = true;
                    }
                }                
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newServices.push(item);

            return true;
        });

        setItems({...items, services: {...items.services, items: newServices}});
    }, [servicesFilter, setServicesFilter, items, setItems]);

    const toggleFilterActivities = useCallback((target = null, value = null) => {
        const currentActivitiesFilter = activitiesFilter;
        currentActivitiesFilter[target] = value;
        // if (target && value) {
        //     
        // }
        setActivitiesFilter(currentActivitiesFilter);

        let currentActivities = items.activities.items;

        // Changing the items when suggested
        if(target === 'interest') {
            if (value === 'suggested') {
                currentActivities = items.interests.activities.suggested;
            } else {
                currentActivities = items.interests.activities.original;
            }
        }

        if (target === 'interest' && value !== '') {
            currentActivitiesFilter['difficulty'] = '';
            activitiesDifficultyFilter.current.state.value = defaultAllOption;
        }
        
        let newActivities = [];

        currentActivities.map((item) => {
            let validation = true;
            
            // Difficulty filter
            if (currentActivitiesFilter.difficulty !== undefined && currentActivitiesFilter.difficulty !== null && currentActivitiesFilter.difficulty !== '') {
                if (parseInt(item.difficulty) !== parseInt(currentActivitiesFilter.difficulty)) {
                    validation = false;
                }
            }
            // Interest filter
            if (currentActivitiesFilter.interest !== undefined && currentActivitiesFilter.interest !== null && currentActivitiesFilter.interest !== '' && currentActivitiesFilter.interest !== 'suggested') {
                if (!item.interests.includes(currentActivitiesFilter.interest)) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newActivities.push(item);

            return true;
        });

        setItems({...items, activities: {...items.activities, items: newActivities} });
    }, [activitiesFilter, setActivitiesFilter, items, setItems, defaultAllOption]);

    const toggleFilterProducts = useCallback((target = null, value = null) => {
        const currentProductsFilter = productsFilter;
        currentProductsFilter[target] = value;
        // if (target && value) {
        //     
        // }
        setProductsFilter(currentProductsFilter);

        let currentProducts = items.products.items;
        
        // Changing the items when suggested
        if(target === 'interest') {
            if (value === 'suggested') {
                currentProducts = items.interests.products.suggested;
            } else {
                currentProducts = items.interests.products.original;
            }
        }

        if (target === 'interest' && value !== '') {
            currentProductsFilter['difficulty'] = '';
            productsDifficultyFilter.current.state.value = defaultAllOption;
        }

        let newProducts = [];

        currentProducts.map((item) => {
            let validation = true;

            // Difficulty filter
            if (currentProductsFilter.difficulty !== undefined && currentProductsFilter.difficulty !== null && currentProductsFilter.difficulty !== '') {
                if (parseInt(item.difficulty) !== parseInt(currentProductsFilter.difficulty)) {
                    validation = false;
                }
            }
            // Interest filter
            if (currentProductsFilter.interest !== undefined && currentProductsFilter.interest !== null && currentProductsFilter.interest !== '' && currentProductsFilter.interest !== 'suggested') {
                if (!item.interests.includes(currentProductsFilter.interest)) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newProducts.push(item);

            return true;
        });

        setItems({...items, products: {...items.products, items: newProducts}});
    }, [productsFilter, setProductsFilter, items, setItems, defaultAllOption]);

    const toggleFilterTraining = useCallback((target = null, value = null) => {
        const currentTrainingFilter = trainingFilter;
        currentTrainingFilter[target] = value;
        // if (target && value) {
        //     
        // }
        setTrainingFilter(currentTrainingFilter);

        let currentTraining = items.training.items;
        
        // Changing the items when suggested
        if(target === 'interest') {
            if (value === 'suggested') {
                currentTraining = items.interests.training.suggested;
            } else {
                currentTraining = items.interests.training.original;
            }
        }

        if (target === 'interest' && value !== '') {
            currentTrainingFilter['difficulty'] = '';
            trainingDifficultyFilter.current.state.value = defaultAllOption;
        }

        let newTraining = [];

        currentTraining.map((item) => {
            let validation = true;

            // Difficulty filter
            if (currentTrainingFilter.difficulty !== undefined && currentTrainingFilter.difficulty !== null && currentTrainingFilter.difficulty !== '') {
                if (parseInt(item.difficulty) !== parseInt(currentTrainingFilter.difficulty)) {
                    validation = false;
                }
            }
            // Interest filter
            if (currentTrainingFilter.interest !== undefined && currentTrainingFilter.interest !== null && currentTrainingFilter.interest !== '' && currentTrainingFilter.interest !== 'suggested') {
                if (!item.interests.includes(currentTrainingFilter.interest)) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newTraining.push(item);

            return true;
        });

        setItems({...items, training: {...items.training, items: newTraining}});
    }, [trainingFilter, setTrainingFilter, items, setItems, defaultAllOption]);

    const toggleFilterVa = useCallback((target = null, value = null) => {
        const currentVaFilter = vaFilter;
        currentVaFilter[target] = value;
        
        setVaFilter(currentVaFilter);

        const currentVa = items.va.items;
        let newVa = [];

        currentVa.map((item) => {
            let validation = true;

            // State filter
            if (currentVaFilter.state !== undefined && currentVaFilter.state !== null && currentVaFilter.state !== '') {
                if (item.state !== undefined && item.state !== currentVaFilter.state) {
                    validation = false;
                }
            }

            if (!validation) {
                item.hide = true;
            } else {
                item.hide = false;
            }
            newVa.push(item);

            return true;
        });

        setItems({...items, va: {...items.va, items: newVa}});
    }, [vaFilter, setVaFilter, items, setItems]);

    const search = useCallback((e) => {
        e.preventDefault();
        let endpoint, params;

        if (searchTypeZip) {
            if (searchParams.zipcode_search === null || searchParams.zipcode_search === undefined || searchParams.zipcode_search === '') {
                toast.error('Please enter a valide ZIP Code');
                return false;
            }

            endpoint = 'ro.team.listResources';
            params = {
                zipcode: parseInt(searchParams.zipcode_search)
            }
        } else {
            if (searchParams.state_search === null || searchParams.state_search === undefined || searchParams.state_search === '') {
                toast.error('Please enter a valid state');
                return false;
            }

            endpoint = 'ro.team.listResources';
            params = {
                state: searchParams.state_search,
            }
        }

        if (endpoint && params) {
            toggleLoading(true);
            toggleActiveSearchScreen();
            setActiveSearch(true);

            api.post(endpoint, params)
                .then((response) => {
                    response.data.interests = {};
                    setActivitiesFilter({});
                    setProductsFilter({});
                    setTrainingFilter({});

                    if (response.data.services.items.length > 0) {
                        setAccordionServices(response.data.services.items.map((item) => true));
                        response.data.services.items = preFilterServices(response.data.services.items);
                        setFilteredLanguages(getLanguagesFromValues(response.data.services.items));
                    }

                    if (response.data.activities.items.length > 0) {
                        setAccordionActivities(response.data.activities.items.map((item) => true));
                        response.data.activities.items = preFilterActivities(response.data.activities.items);
                        response.data.interests.activities = {};
                        response.data.interests.activities.original = response.data.activities.items;
                        response.data.interests.activities.suggested = sortItensByInterest(
                            response.data.activities.items,
                            mountRemoteInterests('activities', response.data.activities.items)
                        );
                        // Set suggested default
                        // if (response.data.interests.activities.suggested.length > 0) {
                        //     response.data.activities = response.data.interests.activities.suggested;
                        // }
                    }

                    if (response.data.products.items.length > 0) {
                        setAccordionProducts(response.data.products.items.map((item) => true));
                        response.data.products.items = preFilterProducts(response.data.products.items);
                        response.data.interests.products = {};
                        response.data.interests.products.original = response.data.products.items;
                        response.data.interests.products.suggested = sortItensByInterest(
                            response.data.products.items,
                            mountRemoteInterests('products', response.data.products.items)
                        );
                        // Set suggested default
                        // if (response.data.interests.products.suggested.length > 0) {
                        //     response.data.products = response.data.interests.products.suggested;
                        // }
                    }
                    
                    if (response.data.training.items.length > 0) {
                        setAccordionTraining(response.data.training.items.map((item) => true));
                        response.data.training.items = preFilterTraining(response.data.training.items);
                        response.data.interests.training = {};
                        response.data.interests.training.original = response.data.training.items;
                        response.data.interests.training.suggested = sortItensByInterest(
                            response.data.training.items,
                            mountRemoteInterests('training', response.data.training.items)
                        );
                        // Set suggested default
                        // if (response.data.interests.training.suggested.length > 0) {
                        //     response.data.training = response.data.interests.training.suggested;
                        // }
                    }

                    if (response.data.va.items.length > 0) {
                        setAccordionVa(response.data.va.items.map((item) => true));
                        response.data.va.items = preFilterVa(response.data.va.items, response.data.state);
                        setFilteredStates(getStatesFromValues(response.data.va.items));
                    }

                    setLastId({
                        services: response.data.services.lastId,
                        activities: response.data.activities.lastId,
                        products: response.data.products.lastId,
                        training: response.data.training.lastId,
                        va: response.data.va.lastId
                    })

                    setItems(response.data);
                })
                .catch((err) => {
                    if (err.response) {
                        toast.error(err.response.data.message);
                    } else {
                        toast.error(err);
                    }                    
                })
                .finally(() => {
                    toggleLoading(false);
                });
        }

    }, [toggleActiveSearchScreen, toggleLoading, searchParams, setActiveSearch, searchTypeZip, setAccordionActivities, setAccordionProducts, setAccordionServices, setAccordionTraining, setAccordionVa, mountRemoteInterests, preFilterServices, preFilterActivities, preFilterProducts, preFilterTraining, preFilterVa, setActivitiesFilter, setProductsFilter,setTrainingFilter, setFilteredLanguages, setFilteredStates, setLastId]);

    // const defaultLanguage = useCallback(() => {        
    //     if (searchParams.language_search !== undefined && searchParams.language_search !== '') {
    //         return { value: searchParams.language_search, label: getKeyByValue(ResourceLanguages, parseInt(searchParams.language_search)) };
    //     } else {
    //         // return { value: '', label: 'ALL' };
    //     }
    // }, [searchParams]);

    // const defaultDifficulty = useCallback(() => {      
    //     if (searchParams.difficulty_search !== undefined && searchParams.difficulty_search !== '') {
    //         return { value: searchParams.difficulty_search, label: getKeyByValue(ResourceDifficulties, parseInt(searchParams.difficulty_search)) };
    //     } else {
    //         return { value: '', label: 'ALL' };
    //     }
    // }, [searchParams]);

    const verifyCheck = useCallback((item) => {
        const interests = searchParams.interests;
        if (interests !== undefined) {
            if (interests.includes(item)) {
                return true;
            }
        }
        return false;
    }, [searchParams]);

    const loadMore = useCallback((type) => {
        let typeRequest;
        let lastIdRequest;
        switch(type) {
            case 'services':
                typeRequest = ResourceTypes.SERVICES;
                lastIdRequest = lastId.services;
                break;
            case 'activities':
                typeRequest = ResourceTypes.ACTIVITIES;
                lastIdRequest = lastId.activities;
                break;
            case 'products':
                typeRequest = ResourceTypes.PRODUCTS;
                lastIdRequest = lastId.products;
                break;
            case 'training':
                typeRequest = ResourceTypes.TRAINING;
                lastIdRequest = lastId.training;
                break;
            case 'va':
                typeRequest = ResourceTypes.VA;
                lastIdRequest = lastId.va;
                break;
            default:
                typeRequest = null;
                break;
        }
        if (typeRequest !== null) {
            let endpoint, params;
            if (searchTypeZip) {    
                endpoint = 'ro.team.listResources';
                params = { zipcode: parseInt(searchParams.zipcode_search) }
            } else {
                endpoint = 'ro.team.listResources';
                params = { state: searchParams.state_search }
            }

            params.type = typeRequest;
            params.lastId = lastIdRequest;
    
            if (endpoint && params) {
                toggleLoading(true);
    
                api.post(endpoint, params)
                    .then((response) => {

                        let newItems = [];
                        switch(type) {
                            case 'services':
                                newItems = [...items.services.items, ...response.data.items];
                                setAccordionServices(newItems.map((item) => true));
                                let newServices = {...items.services, items: newItems};
                                setItems({...items, services: newServices});
                                setLastId({...lastId, services: response.data.lastId});
                                break;
                            case 'activities':
                                newItems = [...items.activities.items, ...response.data.items];
                                setAccordionActivities(newItems.map((item) => true));
                                let newActivities = {...items.activities, items: newItems};
                                setItems({...items, activities: newActivities});
                                setLastId({...lastId, activities: response.data.lastId});
                                break;
                            case 'products':
                                newItems = [...items.products.items, ...response.data.items];
                                setAccordionProducts(newItems.map((item) => true));
                                let newProducts = {...items.products, items: newItems};
                                setItems({...items, products: newProducts});
                                setLastId({...lastId, products: response.data.lastId});
                                break;
                            case 'training':
                                newItems = [...items.training.items, ...response.data.items];
                                setAccordionTraining(newItems.map((item) => true));
                                let newTraining = {...items.training, items: newItems};
                                setItems({...items, training: newTraining});
                                setLastId({...lastId, training: response.data.lastId});
                                break;
                            case 'va':
                                newItems = [...items.va.items, ...response.data.items];
                                setAccordionVa(newItems.map((item) => true));
                                let newVa = {...items.va, items: newItems};
                                setItems({...items, va: newVa});
                                setLastId({...lastId, va: response.data.lastId});
                                break;
                            default:
                                break;
                        }
                    })
                    .catch((err) => {
                        if (err.response) {
                            toast.error(err.response.data.message);
                        } else {
                            toast.error(err);
                        }                    
                    })
                    .finally(() => {
                        toggleLoading(false);
                    });
            }
        }
    }, [toggleLoading, searchTypeZip, items, searchParams, lastId, setLastId, setAccordionActivities, setAccordionProducts, setAccordionTraining, setAccordionVa, setAccordionServices]);

    return (
        <Fragment>
            <Container fluid>
                <Row className="mb-2">
                    <Col sm="6">
                        {activeSearch === true && activeAddScreen === false && (
                            <Fragment>
                                <Button
                                    className="btn-icon btn-icon-only" 
                                    color="primary"
                                    onClick={toggleActiveSearchScreen}
                                >
                                    {activeSearch === false && activeSearchScreen === true && (
                                        <FontAwesomeIcon
                                            icon={faSearch}
                                            size="1x"
                                        />
                                    )}
                                    {activeSearch === true && activeSearchScreen === false && (
                                        <Fragment>Change search</Fragment>
                                    )}
                                    {activeSearch === true && activeSearchScreen === true && (
                                        <Fragment>Last search</Fragment>
                                    )}
                                </Button> 
                            </Fragment>
                        )}
                                               
                    </Col>
                    <Col sm="6" className="text-right">
                        <Button 
                            className="btn-icon btn-icon-only" 
                            color="success"
                            onClick={toggleActiveAddScreen}
                        >
                            {activeAddScreen === true && (
                                <Fragment>Search Resources</Fragment>
                            )}
                            {activeAddScreen === false && (
                                <Fragment>Add Resource</Fragment>
                            )}
                        </Button>  
                    </Col>
                </Row>

                <Row
                    className={classnames(
                        {
                            'd-none': activeAddScreen,
                        }
                    )}
                >
                    <Col
                        lg={{
                            size: 8,
                            offset: 2,
                        }}
                        className={classnames(
                            {
                                'd-none': !activeSearchScreen,
                            }
                        )}
                    >
                        <Card className="main-card p-3">
                            <h5>Search Resources</h5>
                            <Form className="mt-3">
                                <FormGroup row>
                                    <Col
                                        sm={{size:4}}
                                        md={{size:3}}
                                    >
                                        <FormGroup check>
                                            <Label check>
                                                <Input 
                                                    type="radio"
                                                    checked={!searchTypeZip}
                                                    onChange={toggleSearchTypeZip}
                                                /> 
                                                    By State 
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                    <Col
                                        sm={{size:8}}
                                        md={{size:4}}
                                    >
                                        <select
                                            name="state_search"
                                            id="state_search"
                                            className="form-control"
                                            onChange={toggleSearchParams}
                                            defaultValue={searchParams.state_search}
                                            key={`${Math.floor((Math.random() * 1000))}-min`}
                                            onClick={() => {
                                                if (searchTypeZip) {
                                                    toggleSearchTypeZip();
                                                }
                                            }}
                                        >
                                            <option>Select</option>
                                            {UsaStates.map((item) => (
                                                <option
                                                    key={item.code}
                                                    value={item.code}
                                                >
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col
                                        sm={{size:4}}
                                        md={{size:3}}
                                    >
                                        <FormGroup check>
                                            <Label check>
                                                <Input 
                                                    type="radio"
                                                    checked={searchTypeZip}
                                                    onChange={toggleSearchTypeZip}
                                                /> 
                                                    By ZIP code 
                                            </Label>
                                        </FormGroup>
                                    </Col>
                                    <Col
                                        sm={{size:8}}
                                        md={{size:4}}
                                    >
                                        <input
                                            name="zipcode_search"
                                            id="zipcode_search"
                                            type="text"
                                            className="form-control"
                                            placeholder="ZIP Code"
                                            onChange={toggleSearchParams}
                                            onClick={() => {
                                                if (!searchTypeZip) {
                                                    toggleSearchTypeZip();
                                                }
                                            }}
                                            defaultValue={searchParams.zipcode_search}
                                        />
                                    </Col>
                                </FormGroup>
                                {/* <FormGroup row>
                                    <Col
                                        sm={{size:12}}
                                        md={{size:6,offset:3}}
                                    >
                                        <select
                                            name="language_search"
                                            id="language_search"
                                            className="form-control"
                                            onChange={toggleSearchParams}
                                            defaultValue={searchParams.language_search}
                                        >
                                            <option value="">Language</option>
                                            <option value="">All</option>
                                            <option value={ResourceLanguages.ENGLISH}>English</option>
                                            <option value={ResourceLanguages.SPANISH}>Spanish</option>
                                        </select>
                                    </Col>
                                </FormGroup> */}
                                {/* <FormGroup row>
                                    <Col
                                        sm={{size:12}}
                                        md={{size:6,offset:3}}
                                    >
                                        <select
                                            name="difficulty_search"
                                            id="difficulty_search"
                                            className="form-control"
                                            onChange={toggleSearchParams}
                                            defaultValue={searchParams.difficulty_search}
                                        >
                                            <option value="">Difficulty Level</option>
                                            <option value={ResourceDifficulties.EASY}>EASY</option>
                                            <option value={ResourceDifficulties.INTERMEDIATE}>INTERMEDIATE</option>
                                            <option value={ResourceDifficulties.ADVANCED}>ADVANCED</option>
                                        </select>
                                    </Col>
                                </FormGroup> */}
                                <FormGroup row>
                                    <Col sm="12">
                                        <Label>Interests</Label>
                                    </Col>

                                    {predefinedInterests.map((item) => (
                                        <Col sm="4" key={item.value}>
                                            <FormGroup check>
                                                <Label check className="interests-search-option">
                                                    <Input
                                                        type="checkbox"
                                                        value={item.value}
                                                        onChange={toggleInterests}
                                                        checked={verifyCheck(item.value)}
                                                    />
                                                    {' '}
                                                    {item.label}
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    ))}

                                </FormGroup>
                                <FormGroup>
                                    <Button
                                        color="primary"
                                        onClick={search}
                                    >
                                        Search
                                    </Button>
                                </FormGroup>
                            </Form>
                        </Card>
                    </Col>

                    <Col
                        lg={activeSearchScreen ? '8' : '12'}
                        className={classnames(
                            {
                                'd-none': activeSearchScreen,
                            }
                        )}
                    >

                        <Tabs
                            defaultActiveKey="1"
                            renderTabBar={() => <ScrollableInkTabBar/>}
                            renderTabContent={() => <TabContent/>}
                        >
                            <TabPane tab='Services' key="1">
                                <Card>
                                    <CardHeader style={{textTransform: 'none', height: 'auto'}}>
                                    <h4>Agencies, Community Programs, and other Services</h4>
                                    </CardHeader>
                                    {items && items.services.items && items.services.items.length > 0 && (
                                        <CardBody>
                                            <Row>
                                                <Col sm="4">
                                                    <Select
                                                        options={filteredLanguages}
                                                        placeholder="Filter by language"
                                                        onChange={(e) => { toggleFilterServices('language', e.value) }}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        ref={servicesLanguageFilter}
                                                    />
                                                </Col>
                                                {/* <Col sm="4">
                                                    STATE
                                                </Col>
                                                <Col sm="4">
                                                    ZIP CODE
                                                </Col> */}
                                            </Row>
                                        </CardBody>
                                    )}
                                </Card>
                                
                                <ListGroup className="todo-list-wrapper" flush>
                                    {items && items.services.items && items.services.items.map((item, index) => 
                                        !item.hide && (
                                            <ListGroupItem key={item.id} className="list-no-border">
                                                <div
                                                    id="accordion"
                                                    className="accordion-wrapper mb-1"
                                                >
                                                    <Card>
                                                        <CardHeader id="headingOne">
                                                            <div style={{width: '100%'}} >
                                                                <div className="widget-content p-0">
                                                                    <div className="widget-content-wrapper">
                                                                        <div className="widget-content-left">
                                                                            <Button
                                                                                color="link"
                                                                                className="text-left m-0 p-0"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'services')
                                                                                }
                                                                                aria-expanded={accordionServices[index]}
                                                                                aria-controls="collapseOne"
                                                                            >
                                                                                <h5 className="m-0 p-0">
                                                                                    {item.title}
                                                                                </h5>
                                                                            </Button>
                                                                            {/* <div className="ml-3 badge badge-primary">Badge</div> */}
                                                                        </div>

                                                                        <div className="widget-content-right">
                                                                            <FontAwesomeIcon
                                                                                icon={faCaretDown}
                                                                                size="1x"
                                                                                className="hover-cursor-pointer"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'services')
                                                                                }
                                                                                aria-expanded={accordionServices[index]}
                                                                                aria-controls="collapseOne"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardHeader>
                                                        <Collapse
                                                            isOpen={accordionServices[index]}
                                                            data-parent="#accordion"
                                                            id="collapseOne"
                                                            aria-labelledby="headingOne"
                                                        >
                                                            <CardBody>
                                                                {item.thumb && (
                                                                    <CardImg
                                                                        width="100px"
                                                                        src={item.thumb}
                                                                        alt={item.title}
                                                                        className="mr-2"
                                                                    />
                                                                )}                                                            
                                                                {item.desc}
                                                                <Row className="align-items-center mt-3">
                                                                    <Col>
                                                                        <div className="text-left">
                                                                            <Button
                                                                                size="sm"
                                                                                color="info"
                                                                                className="mr-1 mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.SERVICES
                                                                                    })
                                                                                    toggleModalRate();
                                                                                }}
                                                                            >
                                                                                Review
                                                                            </Button>
                                                                            <Button
                                                                                size="sm"
                                                                                color="secondary"
                                                                                className="mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.SERVICES
                                                                                    })
                                                                                    toggleModalReport();
                                                                                }}
                                                                            >
                                                                                Report
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="text-right">
                                                                            {item.url !== undefined && item.url && (
                                                                                <a
                                                                                    href={prettyUrl(item.url)}
                                                                                    className="btn-shadow ml-2 btn btn-primary"
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    Access Resource
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                </div>
                                            </ListGroupItem>
                                        )
                                    )}
                                </ListGroup>
                                {lastId.services !== undefined && lastId.services !== null && (
                                    <div className="text-center">
                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            size="md"
                                            color="info"
                                            onClick={() => loadMore('services')}
                                        >
                                            Load more
                                        </Button>
                                    </div>
                                )}
                                {items && items.services.items && items.services.items.length === 0 && (
                                    <Card className="mt-3">
                                        <CardBody>
                                            <p>No registered resources yet. Change search for more results.</p>
                                        </CardBody>
                                    </Card>
                                )}
                            </TabPane>

                            <TabPane tab='Activities' key="2">
                                <Card>
                                    <CardHeader style={{textTransform: 'none'}}>
                                        <h4>Activities, Ideas, Resources and Information</h4>
                                    </CardHeader>
                                    {items && items.interests && items.interests.activities && items.interests.activities.original && items.interests.activities.original.length > 0 && (
                                        <CardBody>
                                            <Row>
                                                <Col sm="6">
                                                    <Select
                                                        options={returnedInterestsActivities}
                                                        // defaultValue={defaultSuggestedOption}
                                                        placeholder="Filter by Topic"
                                                        onChange={(e) => {toggleFilterActivities('interest', e.value);}}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        ref={activitiesInterestFilter}
                                                    />
                                                </Col>
                                                <Col sm="6">
                                                    <Select
                                                        options={difficultyOptions}
                                                        placeholder="Filter by Difficulty"
                                                        onChange={(e) => { toggleFilterActivities('difficulty', e.value) }}
                                                        // defaultValue={defaultDifficulty()}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        ref={activitiesDifficultyFilter}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    )}  
                                </Card>
                                                              
                                <ListGroup className="todo-list-wrapper" flush>
                                    {items && items.activities.items && items.activities.items.map((item, index) => 
                                        !item.hide && (
                                            <ListGroupItem key={item.id} className="list-no-border">
                                                <div
                                                    id="accordion"
                                                    className="accordion-wrapper mb-1"
                                                >
                                                    <Card>
                                                        <CardHeader id="headingOne">
                                                            <div style={{width: '100%'}} >
                                                                <div className="widget-content p-0">
                                                                    <div className="widget-content-wrapper">
                                                                        <div className="widget-content-left">
                                                                            <Button
                                                                                color="link"
                                                                                className="text-left m-0 p-0"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'activities')
                                                                                }
                                                                                aria-expanded={accordionActivities[index]}
                                                                                aria-controls="collapseOne"
                                                                            >
                                                                                <h5 className="m-0 p-0">
                                                                                    {item.title}
                                                                                </h5>
                                                                            </Button>
                                                                            {item.suggested && (
                                                                                <div className="ml-3 badge badge-primary">
                                                                                    {suggestedBadge}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="widget-content-right">
                                                                            <FontAwesomeIcon
                                                                                icon={faCaretDown}
                                                                                size="1x"
                                                                                className="hover-cursor-pointer"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'activities')
                                                                                }
                                                                                aria-expanded={accordionActivities[index]}
                                                                                aria-controls="collapseOne"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardHeader>
                                                        <Collapse
                                                            isOpen={accordionActivities[index]}
                                                            data-parent="#accordion"
                                                            id="collapseOne"
                                                            aria-labelledby="headingOne"
                                                        >
                                                            <CardBody>
                                                                {item.thumb && (
                                                                    <CardImg
                                                                        width="100px"
                                                                        src={item.thumb}
                                                                        alt={item.title}
                                                                        className="mr-2"
                                                                    />
                                                                )}   
                                                                {item.desc}
                                                                <Row className="align-items-center mt-3">
                                                                    <Col>
                                                                        <div className="text-left">
                                                                            <Button
                                                                                size="sm"
                                                                                color="info"
                                                                                className="mr-1 mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.ACTIVITIES
                                                                                    })
                                                                                    toggleModalRate();
                                                                                }}
                                                                            >
                                                                                Review
                                                                            </Button>
                                                                            <Button
                                                                                size="sm"
                                                                                color="secondary"
                                                                                className="mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.ACTIVITIES
                                                                                    })
                                                                                    toggleModalReport();
                                                                                }}
                                                                            >
                                                                                Report
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="text-right">
                                                                            {item.url !== undefined && item.url && (
                                                                                <a
                                                                                    href={prettyUrl(item.url)}
                                                                                    className="btn-shadow ml-2 btn btn-primary"
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    Visit Website
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                </div>
                                            </ListGroupItem>
                                        )
                                    )}
                                </ListGroup>
                                {lastId.activities !== undefined && lastId.activities !== null && (
                                    <div className="text-center">
                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            size="md"
                                            color="info"
                                            onClick={() => loadMore('activities')}
                                        >
                                            Load more
                                        </Button>
                                    </div>
                                )}
                                {items && items.interests && items.interests.activities && items.interests.activities.original && items.interests.activities.original.length === 0 && (
                                    <Card className="mt-3">
                                        <CardBody>
                                            <p>No registered resources yet. Change search for more results.</p>
                                        </CardBody>
                                    </Card>
                                )}
                            </TabPane>

                            <TabPane tab='Products' key="3">
                                <Card>
                                    <CardHeader style={{textTransform: 'none'}}>
                                        <h4>Products, Technology and Tools</h4>
                                    </CardHeader>
                                    {items && items.interests && items.interests.products && items.interests.products.original && items.interests.products.original.length > 0 && (
                                        <CardBody>
                                            <Row>
                                                <Col sm="6">
                                                    <Select
                                                        options={returnedInterestsProducts}
                                                        // defaultValue={defaultSuggestedOption}
                                                        placeholder="Filter by Topic"
                                                        onChange={(e) => { toggleFilterProducts('interest', e.value) }}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        ref={productsInterestFilter}
                                                    />
                                                </Col>
                                                <Col sm="6">
                                                    <Select
                                                        options={difficultyOptions}
                                                        placeholder="Filter by Difficulty"
                                                        onChange={(e) => { toggleFilterProducts('difficulty', e.value) }}
                                                        // defaultValue={defaultDifficulty()}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        ref={productsDifficultyFilter}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    )}
                                </Card>
                                
                                <ListGroup className="todo-list-wrapper" flush>
                                    {items && items.products.items && items.products.items.map((item, index) => 
                                        !item.hide && (
                                            <ListGroupItem key={item.id} className="list-no-border">
                                                <div
                                                    id="accordion"
                                                    className="accordion-wrapper mb-1"
                                                >
                                                    <Card>
                                                        <CardHeader id="headingOne">
                                                            <div style={{width: '100%'}} >
                                                                <div className="widget-content p-0">
                                                                    <div className="widget-content-wrapper">
                                                                        <div className="widget-content-left">
                                                                            <Button
                                                                                color="link"
                                                                                className="text-left m-0 p-0"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'products')
                                                                                }
                                                                                aria-expanded={accordionProducts[index]}
                                                                                aria-controls="collapseOne"
                                                                            >
                                                                                <h5 className="m-0 p-0">
                                                                                    {item.title}
                                                                                </h5>
                                                                            </Button>
                                                                            {item.suggested && (
                                                                                <div className="ml-3 badge badge-primary">
                                                                                    {suggestedBadge}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="widget-content-right">
                                                                            <FontAwesomeIcon
                                                                                icon={faCaretDown}
                                                                                size="1x"
                                                                                className="hover-cursor-pointer"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'products')
                                                                                }
                                                                                aria-expanded={accordionProducts[index]}
                                                                                aria-controls="collapseOne"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardHeader>
                                                        <Collapse
                                                            isOpen={accordionProducts[index]}
                                                            data-parent="#accordion"
                                                            id="collapseOne"
                                                            aria-labelledby="headingOne"
                                                        >
                                                            <CardBody>
                                                                {item.thumb && (
                                                                    <CardImg
                                                                        width="100px"
                                                                        src={item.thumb}
                                                                        alt={item.title}
                                                                        className="mr-2"
                                                                    />
                                                                )}   
                                                                {item.desc}
                                                                {item.brand && (
                                                                    <p className="mt-2"><i>By:</i> {item.brand}</p>
                                                                )}
                                                                <Row className="align-items-center mt-3">
                                                                    <Col>
                                                                        <div className="text-left">
                                                                            <Button
                                                                                size="sm"
                                                                                color="info"
                                                                                className="mr-1 mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.PRODUCTS
                                                                                    })
                                                                                    toggleModalRate();
                                                                                }}
                                                                            >
                                                                                Review
                                                                            </Button>
                                                                            <Button
                                                                                size="sm"
                                                                                color="secondary"
                                                                                className="mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.PRODUCTS
                                                                                    })
                                                                                    toggleModalReport();
                                                                                }}
                                                                            >
                                                                                Report
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="text-right">
                                                                            {item.url !== undefined && item.url && (
                                                                                <a
                                                                                    href={prettyUrl(item.url)}
                                                                                    className="btn-shadow ml-2 btn btn-primary"
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    Learn more
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                </div>
                                            </ListGroupItem>
                                        )
                                    )}
                                </ListGroup>
                                {lastId.products !== undefined && lastId.products !== null && (
                                    <div className="text-center">
                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            size="md"
                                            color="info"
                                            onClick={() => loadMore('products')}
                                        >
                                            Load more
                                        </Button>
                                    </div>
                                )}
                                {items && items.interests && items.interests.products && items.interests.products.original && items.interests.products.original.length === 0 && (
                                    <Card className="mt-3">
                                        <CardBody>
                                            <p>No registered resources yet. Change search for more results.</p>
                                        </CardBody>
                                    </Card>
                                )}
                            </TabPane>

                            <TabPane tab='Videos' key="4">
                                <Card>
                                    <CardHeader style={{textTransform: 'none'}}>
                                        <h4>Tech Training, Music, Inspiration and other Videos</h4>
                                    </CardHeader>
                                    {items && items.interests && items.interests.training && items.interests.training.original && items.interests.training.original.length > 0 && (
                                        <CardBody>
                                            <Row>
                                                <Col sm="6">
                                                    <Select
                                                        options={returnedInterestsTraining}
                                                        // defaultValue={defaultSuggestedOption}
                                                        placeholder="Filter by Topic"
                                                        onChange={(e) => { toggleFilterTraining('interest', e.value) }}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        ref={trainingInterestFilter}
                                                    />
                                                </Col>
                                                <Col sm="6">
                                                    <Select
                                                        options={difficultyOptions}
                                                        placeholder="Filter by Difficulty"
                                                        onChange={(e) => { toggleFilterTraining('difficulty', e.value) }}
                                                        // defaultValue={defaultDifficulty()}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        ref={trainingDifficultyFilter}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    )}
                                </Card>                           
                                <ListGroup className="todo-list-wrapper" flush>
                                    {items && items.training.items && items.training.items.map((item, index) => 
                                        !item.hide && (
                                            <ListGroupItem key={item.id} className="list-no-border">
                                                <div
                                                    id="accordion"
                                                    className="accordion-wrapper mb-1"
                                                >
                                                    <Card>
                                                        <CardHeader id="headingOne">
                                                            <div style={{width: '100%'}} >
                                                                <div className="widget-content p-0">
                                                                    <div className="widget-content-wrapper">
                                                                        <div className="widget-content-left">
                                                                            <Button
                                                                                color="link"
                                                                                className="text-left m-0 p-0"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'training')
                                                                                }
                                                                                aria-expanded={accordionTraining[index]}
                                                                                aria-controls="collapseOne"
                                                                            >
                                                                                <h5 className="m-0 p-0">
                                                                                    {item.title}
                                                                                </h5>
                                                                            </Button>
                                                                            {item.suggested && (
                                                                                <div className="ml-3 badge badge-primary">
                                                                                    {suggestedBadge}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="widget-content-right">
                                                                            <FontAwesomeIcon
                                                                                icon={faCaretDown}
                                                                                size="1x"
                                                                                className="hover-cursor-pointer"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'training')
                                                                                }
                                                                                aria-expanded={accordionTraining[index]}
                                                                                aria-controls="collapseOne"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardHeader>
                                                        <Collapse
                                                            isOpen={accordionTraining[index]}
                                                            data-parent="#accordion"
                                                            id="collapseOne"
                                                            aria-labelledby="headingOne"
                                                        >
                                                            <CardBody>
                                                                {item.thumb && (
                                                                    <CardImg
                                                                        width="100px"
                                                                        src={item.thumb}
                                                                        alt={item.title}
                                                                        className="mr-2"
                                                                    />
                                                                )}
                                                                {item.url !== undefined && item.url && detectYouTubeUrl(item.url) && (
                                                                    <Row>
                                                                        <Col md="12" className="mb-3">
                                                                            <ReactPlayer url={item.url} width='640px' height='360px' style={{margin:'auto',maxWidth:'100%'}} controls={true} />
                                                                        </Col>
                                                                        <Col md="12">
                                                                            {item.desc}
                                                                        </Col>
                                                                    </Row>
                                                                )}
                                                                {!detectYouTubeUrl(item.url) && (
                                                                    <Fragment>
                                                                        {item.desc}
                                                                    </Fragment>
                                                                )}
                                                                
                                                                
                                                                <Row className="align-items-center mt-3">
                                                                    <Col>
                                                                        <div className="text-left">
                                                                            <Button
                                                                                size="sm"
                                                                                color="info"
                                                                                className="mr-1 mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.TRAINING
                                                                                    })
                                                                                    toggleModalRate();
                                                                                }}
                                                                            >
                                                                                Review
                                                                            </Button>
                                                                            <Button
                                                                                size="sm"
                                                                                color="secondary"
                                                                                className="mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.TRAINING
                                                                                    })
                                                                                    toggleModalReport();
                                                                                }}
                                                                            >
                                                                                Report
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="text-right">
                                                                            {item.url !== undefined && item.url && (
                                                                                <a
                                                                                    href={prettyUrl(item.url)}
                                                                                    className="btn-shadow ml-2 btn btn-primary"
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    Watch on Youtube
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                </div>
                                            </ListGroupItem>
                                        )
                                    )}
                                </ListGroup>
                                {lastId.training !== undefined && lastId.training !== null && (
                                    <div className="text-center">
                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            size="md"
                                            color="info"
                                            onClick={() => loadMore('training')}
                                        >
                                            Load more
                                        </Button>
                                    </div>
                                )}
                                {items && items.interests && items.interests.training && items.interests.training.original && items.interests.training.original.length === 0 && (
                                    <Card className="mt-3">
                                        <CardBody>
                                            <p>No registered resources yet. Change search for more results.</p>
                                        </CardBody>
                                    </Card>
                                )}
                            </TabPane>

                            <TabPane tab='Veterans' key="5">
                                <Card>
                                    <CardHeader style={{textTransform: 'none'}}>
                                        <h4>Veteran Directed Care Program</h4>
                                    </CardHeader>
                                    {items && items.va.items && items.va.items.length > 0 && (
                                        <CardBody>
                                            <Row>
                                                <Col sm="4">
                                                    <Select
                                                        options={filteredStates}
                                                        placeholder="Filter by State"
                                                        onChange={(e) => { toggleFilterVa('state', e.value) }}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        ref={vaStateFilter}
                                                        defaultValue={defaultStateVa}
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    )}
                                </Card>
                                <ListGroup className="todo-list-wrapper" flush>
                                    {items && items.va.items && items.va.items.map((item, index) => 
                                        !item.hide && (
                                            <ListGroupItem key={item.id} className="list-no-border">
                                                <div
                                                    id="accordion"
                                                    className="accordion-wrapper mb-1"
                                                >
                                                    <Card>
                                                        <CardHeader id="headingOne">
                                                            <div style={{width: '100%'}} >
                                                                <div className="widget-content p-0">
                                                                    <div className="widget-content-wrapper">
                                                                        <div className="widget-content-left">
                                                                            <Button
                                                                                color="link"
                                                                                className="text-left m-0 p-0"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'va')
                                                                                }
                                                                                aria-expanded={accordionVa[index]}
                                                                                aria-controls="collapseOne"
                                                                            >
                                                                                <h5 className="m-0 p-0">
                                                                                    {item.title}
                                                                                </h5>
                                                                            </Button>
                                                                            {/* <div className="ml-3 badge badge-primary">
                                                                                {UsaStatesJson[item.state]}
                                                                            </div> */}
                                                                        </div>

                                                                        <div className="widget-content-right">
                                                                            <FontAwesomeIcon
                                                                                icon={faCaretDown}
                                                                                size="1x"
                                                                                className="hover-cursor-pointer"
                                                                                onClick={() =>
                                                                                    toggleAccordion(index, 'va')
                                                                                }
                                                                                aria-expanded={accordionVa[index]}
                                                                                aria-controls="collapseOne"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </CardHeader>
                                                        <Collapse
                                                            isOpen={accordionVa[index]}
                                                            data-parent="#accordion"
                                                            id="collapseOne"
                                                            aria-labelledby="headingOne"
                                                        >
                                                            <CardBody>
                                                                {item.thumb && (
                                                                    <CardImg
                                                                        width="100px"
                                                                        src={item.thumb}
                                                                        alt={item.title}
                                                                        className="mr-2"
                                                                    />
                                                                )}   
                                                                {item.desc}
                                                                <Row className="align-items-center mt-3">
                                                                    <Col>
                                                                        <div className="text-left">
                                                                            <Button
                                                                                size="sm"
                                                                                color="info"
                                                                                className="mr-1 mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.VA
                                                                                    })
                                                                                    toggleModalRate();
                                                                                }}
                                                                            >
                                                                                Review
                                                                            </Button>
                                                                            <Button
                                                                                size="sm"
                                                                                color="secondary"
                                                                                className="mb-2 reportBtn"
                                                                                onClick={() => {
                                                                                    setCurrentResourceModal({
                                                                                        id: item.id,
                                                                                        type: ResourceTypes.VA
                                                                                    })
                                                                                    toggleModalReport();
                                                                                }}
                                                                            >
                                                                                Report
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                    <Col>
                                                                        <div className="text-right">
                                                                            {item.url !== undefined && item.url && (
                                                                                <a
                                                                                    href={prettyUrl(item.url)}
                                                                                    className="btn-shadow ml-2 btn btn-primary"
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    Go to Resource
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                
                                                            </CardBody>
                                                        </Collapse>
                                                    </Card>
                                                </div>
                                            </ListGroupItem>
                                        )
                                    )}
                                </ListGroup>
                                {lastId.va !== undefined && lastId.va !== null && (
                                    <div className="text-center">
                                        <Button
                                            className="btn-wide mb-2 mr-2"
                                            size="md"
                                            color="info"
                                            onClick={() => loadMore('va')}
                                        >
                                            Load more
                                        </Button>
                                    </div>
                                )}
                                {items && items.va.items && items.va.items.length === 0 && (
                                    <Card className="mt-3">
                                        <CardBody>
                                            <p>No registered resources yet. Change search for more results.</p>
                                        </CardBody>
                                    </Card>
                                )}
                            </TabPane>

                        </Tabs>

                    </Col>

                </Row>

                <Row
                    className={classnames(
                        {
                            'd-none': !activeAddScreen,
                        }
                    )}
                >
                    <Col
                        lg={{
                            size: 8,
                            offset: 2,
                        }}
                    >
                        <Card className="main-card p-3">
                            <h5 className="mb-3">Submit a Resource</h5>
                            <Form>
                            <FormGroup row>
                                    <Col sm="4">
                                        <select
                                            name="type"
                                            id="type"
                                            className="form-control"
                                            ref={register}
                                        >
                                            <option value="">Select a type</option>
                                            <option value={ResourceTypes.SERVICES}>Services</option>
                                            <option value={ResourceTypes.ACTIVITIES}>Activities</option>
                                            <option value={ResourceTypes.PRODUCTS}>Products</option>
                                            <option value={ResourceTypes.TRAINING}>Videos</option>
                                            <option value={ResourceTypes.VA}>Veteran Affairs</option>
                                            <option value={ResourceTypes.OTHER}>Other</option>
                                        </select>
                                        {errors.type && (
                                            <p className="error-validation-left">
                                                {errors.type}
                                            </p>
                                        )}
                                    </Col>
                                    <Col sm="4">
                                        <select
                                            name="difficulty"
                                            id="difficulty"
                                            className="form-control"
                                            ref={register}
                                        >
                                            <option value="">Select a difficulty level</option>
                                            <option value={ResourceDifficulties.EASY}>Easy</option>
                                            <option value={ResourceDifficulties.INTERMEDIATE}>Intermediate</option>
                                            <option value={ResourceDifficulties.ADVANCED}>Advanced</option>
                                        </select>
                                        {errors.difficulty && (
                                            <p className="error-validation-left">
                                                {errors.difficulty}
                                            </p>
                                        )}
                                    </Col>
                                    <Col sm="4">
                                        <select
                                            name="language"
                                            id="language"
                                            className="form-control"
                                            ref={register}
                                        >
                                            <option value="">Select a language</option>

                                            {/* <option value={ResourceLanguages.ENGLISH}>English</option>
                                            <option value={ResourceLanguages.SPANISH}>SPANISH</option>
                                            <option value={ResourceLanguages.OTHER}>OTHER</option> */}

                                            <option value={ResourceLanguages.ENGLISH}>English</option>
                                            <option value={ResourceLanguages.ARABIC}>Arabic</option>
                                            <option value={ResourceLanguages.CANTONESE}>Cantonese</option>
                                            <option value={ResourceLanguages.CHINESE}>Chinese</option>
                                            <option value={ResourceLanguages.FILIPINO}>Filipino</option>
                                            <option value={ResourceLanguages.FRENCH}>French</option>
                                            <option value={ResourceLanguages.GERMAN}>German</option>
                                            <option value={ResourceLanguages.HAITIAN}>Haitian</option>
                                            <option value={ResourceLanguages.HINDI}>Hindi</option>
                                            <option value={ResourceLanguages.ITALIAN}>Italian</option>
                                            <option value={ResourceLanguages.JAPANESE}>Japanese</option>
                                            <option value={ResourceLanguages.KOREAN}>Korean</option>
                                            <option value={ResourceLanguages.MANDARIN}>Mandarin</option>
                                            <option value={ResourceLanguages.OTHER}>Other</option>
                                            <option value={ResourceLanguages.PERSIAN}>Persian</option>
                                            <option value={ResourceLanguages.POLISH}>Polish</option>
                                            <option value={ResourceLanguages.PORTUGUESE}>Portuguese</option>
                                            <option value={ResourceLanguages.RUSSIAN}>Russian</option>
                                            <option value={ResourceLanguages.SPANISH}>Spanish</option>
                                            <option value={ResourceLanguages.TAGALOG}>Tagalog</option>
                                            <option value={ResourceLanguages.URDU}>Urdu</option>
                                            <option value={ResourceLanguages.VIETNAMESE}>Vietnamese</option>
                                            <option value={ResourceLanguages.YIDDISH}>Yiddish</option>

                                        </select>
                                        {errors.language && (
                                            <p className="error-validation-left">
                                                {errors.language}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="12">
                                        <input
                                            name="title"
                                            id="title"
                                            type="text"
                                            className="form-control"
                                            placeholder="Title"
                                            ref={register}
                                        />
                                        {errors.title && (
                                            <p className="error-validation-left">
                                                {errors.title}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="12">
                                        <textarea
                                            name="description"
                                            id="description"
                                            className="form-control"
                                            placeholder="Description"
                                            ref={register}
                                            rows="3"
                                        >
                                        </textarea>
                                        {errors.description && (
                                            <p className="error-validation-left">
                                                {errors.description}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="12">
                                        <input
                                            name="tags"
                                            id="tags"
                                            type="text"
                                            className="form-control"
                                            placeholder="Topics (separated by commas)"
                                            ref={register}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="12">
                                        <input
                                            name="url"
                                            id="url"
                                            type="text"
                                            className="form-control"
                                            placeholder="URL"
                                            ref={register}
                                        />
                                        {errors.url && (
                                            <p className="error-validation-left">
                                                {errors.url}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="6">
                                        <input
                                            name="street"
                                            id="street"
                                            type="text"
                                            className="form-control"
                                            placeholder="Street"
                                            ref={register}
                                        />
                                    </Col>
                                    <Col sm="6">
                                        <input
                                            name="city"
                                            id="city"
                                            type="text"
                                            className="form-control"
                                            placeholder="City"
                                            ref={register}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="6">
                                        <select
                                            name="state"
                                            id="state"
                                            className="form-control"
                                            ref={register}
                                        >
                                            <option value="">Select</option>
                                            {UsaStates.map((item) => (
                                                <option key={item.code} value={item.code}>{item.name}</option>
                                            ))}
                                        </select>
                                        {errors.state && (
                                            <p className="error-validation-left">
                                                {errors.state}
                                            </p>
                                        )}
                                    </Col>
                                    <Col sm="6">
                                        <input
                                            name="zipcode"
                                            id="zipcode"
                                            type="text"
                                            className="form-control"
                                            placeholder="ZIP"
                                            ref={register}
                                        />
                                        {errors.zipcode && (
                                            <p className="error-validation-left">
                                                {errors.zipcode}
                                            </p>
                                        )}
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="12">
                                        <input
                                            name="phone"
                                            id="phone"
                                            type="text"
                                            className="form-control"
                                            placeholder="Phone"
                                            ref={register}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="12">
                                        <input
                                            name="email"
                                            id="email"
                                            type="email"
                                            className="form-control"
                                            placeholder="Email"
                                            ref={register}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row>
                                    <Col sm="12">
                                        <div className="text-center">
                                            <Button
                                                color="primary"
                                                onClick={handleSubmit(add)}
                                            >
                                                Submit
                                            </Button>
                                        </div>
                                    </Col>
                                </FormGroup>
                            </Form>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={modalSubmitMessage} toggle={toggleModalSubmitMessage}>
                    <ModalHeader toggle={toggleModalSubmitMessage}>
                        Resource submitted
                    </ModalHeader>
                    <ModalBody>
                        <p>Thank you! Senior Link will review your submitted resource. After approval, it will be available to all participants.</p>
                        <div className="text-center">
                            <Button
                                color="secondary"
                                onClick={toggleModalSubmitMessage}
                            >
                                OK
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

                {/* START: Modal Rate */}
                <Modal isOpen={modalRate} toggle={toggleModalRate}>
                    <ModalHeader toggle={toggleModalRate}>
                        Review Resource
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup row>
                                <Col sm={{size:12}} md={{size:8,offset:2}}>
                                    <div className="d-flex justify-content-center starts-component">
                                        <ReactStars
                                            count={5}
                                            onChange={ratingChanged}
                                            size={40}
                                            activeColor="#ffd700"
                                        />
                                    </div>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{size:12}} md={{size:8,offset:2}}>
                                    <Label>
                                        Comment
                                    </Label>
                                    <textarea
                                        name="review_text"
                                        id="review_text"
                                        rows="3"
                                        className="form-control"
                                        onChange={contentChanged}
                                    >
                                    </textarea>
                                </Col>
                            </FormGroup>
                        </Form>
                        <div className="text-center mt-4">
                            <Button
                                color="info"
                                className="mr-2"
                                onClick={submitRate}
                            >
                                OK
                            </Button>
                            <Button
                                color="secondary"
                                onClick={toggleModalRate}
                            >
                                Cancel
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalRateMessage} toggle={toggleModalRateMessage}>
                    <ModalHeader toggle={toggleModalRateMessage}>
                        Review sent
                    </ModalHeader>
                    <ModalBody>
                        <p>Thank you for your feedback!</p>
                        <div className="text-center">
                            <Button
                                color="secondary"
                                onClick={toggleModalRateMessage}
                            >
                                OK
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>
                {/* END: Modal Rate */}

                {/* START: Modal Report */}
                <Modal isOpen={modalReport} toggle={toggleModalReport}>
                    <ModalHeader toggle={toggleModalReport}>
                        Report a Concern
                    </ModalHeader>
                    <ModalBody>
                        <Form>
                            <FormGroup row>
                                <Col sm={{size:12}} md={{size:8,offset:2}}>
                                    <Select
                                        options={[
                                            {
                                                value: ReportIssues.NEEDS_UPDATE,
                                                label: 'Resource needs update'
                                            },
                                            {
                                                value: ReportIssues.LINK_BROKEN,
                                                label: 'The link is broken'
                                            },
                                            {
                                                value: ReportIssues.CONTENT_INAPPROPRIATE,
                                                label: 'The Content is inappropriate'
                                            },
                                        ]}
                                        placeholder="Select Issue"
                                        onChange={motivationChanged}
                                    />
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col sm={{size:12}} md={{size:8,offset:2}}>
                                    <Label>
                                        Description
                                    </Label>
                                    <textarea
                                        name="report_text"
                                        id="report_text"
                                        rows="3"
                                        className="form-control"
                                        onChange={descriptionChanged}
                                    >
                                    </textarea>
                                </Col>
                            </FormGroup>
                        </Form>
                        <div className="text-center">
                            <Button
                                color="info"
                                className="mr-2"
                                onClick={submitReport}
                            >
                                OK
                            </Button>
                            <Button
                                color="secondary"
                                onClick={toggleModalReport}
                            >
                                Cancel
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={modalReportMessage} toggle={toggleModalReportMessage}>
                    <ModalHeader toggle={toggleModalReportMessage}>
                        Report sent to Senior Link team
                    </ModalHeader>
                    <ModalBody>
                        <p>Thank you for your feedback! We will review the resource.</p>
                        <div className="text-center">
                            <Button
                                color="secondary"
                                onClick={toggleModalReportMessage}
                            >
                                OK
                            </Button>
                        </div>
                    </ModalBody>
                </Modal>
                {/* END: Modal Report */}

            </Container>
        </Fragment>
    );
}
